"use client"

import React, { useState, useEffect, useRef } from "react";
import Image from "next/image";
import { FormattedMessage, useIntl } from "react-intl";
import { FaBars, FaXmark } from "react-icons/fa6";
import Link from "next/link";
import Scrollspy from "react-scrollspy";

import PAGES, { menuItems } from "@/constants/pages";

import Logo from "@/assets/images/logo/logo_black.png";

const Header = () => {
  const intl = useIntl();

  const [menuOpen, setMenuOpen] = useState(false);
  const headerRef = useRef(null);

  const handleOpenMenu = () => {
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    const body = document.querySelector('body');
    if (menuOpen) {
      body.classList.add('overflow-hidden');
    } else {
      body.classList.remove('overflow-hidden');
    }
  }, [menuOpen]);

  useEffect(() => {
    window.onscroll = function () {
      if (window.pageYOffset >= 100) {
        headerRef.current?.classList?.add('sticky-navbar');
      } else {
        headerRef.current?.classList?.remove('sticky-navbar');
      }
    };
  }, []);


  return (
    <header
      ref={headerRef}
      className="absolute top-0 left-0 z-50 w-full duration-300 bg-white navbar border-stroke dark:border-stroke-dark dark:bg-black"
    >
      <div className="container relative max-w-[1400px]">
        <div className="flex items-center justify-between">
          <div className="block py-4 lg:py-0">
            <Link
              href={PAGES.home}
              title={"Link to home page"}
              className="block max-w-[145px] sm:max-w-[180px]"
            >
              <Image
                src={Logo}
                width={30}
                height={30}
                alt="The Downfor Logo"
                title="Downfor Logo"
              />
            </Link>
          </div>
          <button
            className="navbarOpen absolute right-4 top-1/2 z-50 flex h-10 w-10 -translate-y-1/2 flex-col items-center justify-center space-y-[6px] font-bold lg:hidden"
            aria-label="navbarOpen"
            name="navbarOpen"
            onClick={() => {
              menuOpen
                ? handleCloseMenu()
                : handleOpenMenu()
            }}
          >
            {menuOpen ? (
              <FaXmark
                style={{
                  fontSize: 24
                }}
              />
            ) : (
              <FaBars
                style={{
                  fontSize: 24
                }}
              />
            )}
          </button>

          <div
            className={`relative justify-between menu-wrapper lg:flex ${!menuOpen && "hidden"}`}
          >
            <button
              className="fixed p-2 flex flex-col items-center justify-center w-10 h-10 font-bold navbarClose top-10 right-10 z-9999 lg:hidden"
              name="navbarClose"
              aria-label="navbarClose"
              onClick={handleCloseMenu}
            >
              <span className="block h-[2px] w-7 rotate-45 bg-black dark:bg-white"></span>
              <span className="-mt-[2px] block h-[2px] w-7 -rotate-45 bg-black dark:bg-white"></span>
            </button>

            <nav
              onClick={handleCloseMenu}
              className="fixed top-0 left-0 flex items-center justify-center w-full h-screen text-center z-999 bg-white/95 backdrop-blur-xs dark:bg-black/95 lg:static lg:h-auto lg:w-max lg:bg-transparent lg:backdrop-blur-none lg:dark:bg-transparent"
            >
              <ul className="items-center space-y-3 lg:flex lg:space-x-8 lg:space-y-0 xl:space-x-10">
                <Scrollspy
                  className="items-center space-y-3 lg:flex lg:space-x-8 lg:space-y-0 xl:space-x-10"
                  items={["home", "features", "use-cases", "how-it-works", "pricing", "faq"]}
                  currentClassName="active"
                >
                  {menuItems?.map((item, index) => (
                    <li
                      key={index}
                      className="menu-item"
                    >
                      <Link
                        className="inline-flex items-center text-base font-bold text-black menu-scroll hover:text-primary dark:text-white dark:hover:text-primary lg:py-7"
                        href={item?.href}
                        title={`Link to ${intl.formatMessage({ id: item?.textKey })}`}
                      >
                        <FormattedMessage id={item?.textKey} />
                      </Link>
                    </li>
                  ))}
                </Scrollspy>
              </ul>
            </nav>
          </div>

          <div className="mr-[60px] flex items-center justify-end lg:mr-0">
            <Link
              href={PAGES.admin}
              title={"Link to login page"}
              className="inline-block rounded-md bg-primary py-[5px] px-[20px] text-base font-bold text-white hover:bg-primary/90 sm:py-[10px] sm:px-[30px]"
            >
              <FormattedMessage id="home-page-header-menu-login" />
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;